export const cleanName = (name) => {
  const lower = name.replaceAll('_', ' ').toLowerCase();

  return lower.charAt(0).toUpperCase() + lower.slice(1);
};
